import { getTimelineInterval } from "Areas/SharedFeatures/downSidePanel/redux/selectors";
import { connect } from "react-redux";
import { getClusteredNames } from "../redux/selectors";
import NamesCluster from "./namesCluster";
const mapStateToProps = (state) => ({
    data: getClusteredNames(state),
    timelineInterval: getTimelineInterval(state)
});
export default connect(mapStateToProps)(NamesCluster);
